export default __webpack_public_path__ + "static/media/UBCAthleteHub2.17c6ad9b.png";